import React from 'react';
import { Box, Typography } from '@mui/material';

interface TotalCardProps {
  value: number;
  valueUnit?: string;
}

export const TotalCard = ({ value, valueUnit }: TotalCardProps) => {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
        }}
      >
        {value}
      </Typography>
      <Typography variant="subtitle2" component="div" color="text.secondary">
        {valueUnit}
      </Typography>
    </Box>
  );
};
